module.exports = __webpack_public_path__ + "media/fonts/Oricons-d53e0dde476fc0081449a27a235f12cd.ttf";